import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { RuntimeContext } from '../../../common/RuntimeContext';
import Page from './Page';
import VerbText from './VerbText';
import VerbHeading from './VerbHeading';
import VerbParagraph from './VerbParagraph';
import { useContext } from 'react';

export default class NotFound extends PureComponent {
    static propTypes = {
        userDataLoaded: PropTypes.bool,
        isAdminApp: PropTypes.bool
    };

    static contextType = RuntimeContext;

    render() {
        const { userDataLoaded, isAdminApp } = this.props;

        // Needs to explicitly check against false, not all falsy values
        if (userDataLoaded === false) {
            return null;
        }

        return (
            <Page className={'container'}>
                <div className={'not-found-container'}>
                    <VerbHeading hNumber={1} messageId={'404_TITLE'} defaultMessage={'Oops!'} />
                    <VerbParagraph
                        messageId={'404_SUBTITLE'}
                        defaultMessage={"We can't seem to find the page you're looking for."}
                    />
                    <VerbParagraph
                        messageId={'404_HELPFUL_TEXT'}
                        defaultMessage={'Here are a few links you might find helpful:'}
                    />
                    <ul>
                        {isAdminApp ? (
                            <>
                                <li>
                                    <a href={`${this.context.pathsWeb.clientUrl}/home`}>
                                        <VerbText messageId={'404_HOME_PAGE'} defaultMessage={'Home Page'} />
                                        &nbsp;(app.verb.net)
                                    </a>
                                </li>
                            </>
                        ) : (
                            <>
                                <li>
                                    <Link to={'/home'}>
                                        <VerbText messageId={'404_HOME_PAGE'} defaultMessage={'Home Page'} />
                                        &nbsp;(app.verb.net)
                                    </Link>
                                </li>
                            </>
                        )}
                        <li>
                            <a href={'http://verb.net'}>
                                <VerbText messageId={'404_ABOUT_VERB'} defaultMessage={'About Verb'} />
                                &nbsp;(verb.net)
                            </a>
                        </li>
                    </ul>
                </div>
            </Page>
        );
    }
}
